var React = require('react');

function IconMailSent (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M13.334 47.058H7.88621M18.0629 45.1445V53.7189C18.0629 55.1167 19.1725 56.25 20.5413 56.25H65.0218C66.3905 56.25 67.5 55.1167 67.5 53.7189V26.2732C67.5 25.2248 66.6679 24.375 65.6414 24.375H19.9217C18.8951 24.375 18.0629 25.2248 18.0629 26.2732V35.5598V45.1445ZM66.9528 24.9338L47.5059 41.2522C44.7639 43.5666 40.799 43.5666 38.0572 41.2522L18.6115 24.9351L66.9528 24.9338ZM13.1581 33.4721H6.25H13.1581ZM21.157 40.2855H9.85932H21.157Z","stroke":"black","strokeWidth":"1.875","strokeLinecap":"round","strokeLinejoin":"round"}));
}

IconMailSent.defaultProps = {"width":"80","height":"80","viewBox":"0 0 80 80","fill":"none"};

module.exports = IconMailSent;

IconMailSent.default = IconMailSent;
